import { render, staticRenderFns } from "./zStatusNfse.vue?vue&type=template&id=96538226&scoped=true&"
import script from "./zStatusNfse.vue?vue&type=script&lang=js&"
export * from "./zStatusNfse.vue?vue&type=script&lang=js&"
import style0 from "./zStatusNfse.vue?vue&type=style&index=0&id=96538226&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96538226",
  null
  
)

export default component.exports